export enum PopupType {
    Alert,
    Confirm,
    Success,
    Display,
}
